import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VBtn,_vm._b({attrs:{"small":"","tile":(_vm.title || _vm.hasChildContent) && true,"elevation":"0","icon":_vm.icon && (!_vm.title && !_vm.hasChildContent)},on:{"click":_vm.click}},'v-btn',_vm.$attrs,false),[(_vm.icon)?_c(VIcon,{attrs:{"small":(_vm.title || _vm.hasChildContent) && true}},[_vm._v(" mdi-"+_vm._s(_vm.icon)+" ")]):_vm._e(),_vm._t("default",function(){return [_vm._v(_vm._s(_vm.title || ''))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }